module.exports = "/virtual-football-league/img/amblems/right/logos/FakeCardiffCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeCardiffCity.png
// module id = 2174
// module chunks = 4